import { request } from './request'

export interface DeliveryRule {
  id: string
  storeId?: string
  storeName?: string
  name: string
  minOrderAmount?: number
  baseFee?: number
  freeThreshold?: number
  perKmFee?: number
  startDistanceKm?: number
  maxDistanceKm?: number
  createdAt?: string
}

export interface DeliveryArea {
  id: string
  storeId: string
  storeName?: string
  type: string
  radiusKm?: number
  polygon?: string
  feeTier?: number
  sort?: number
}

export interface DeliveryPoint {
  id: string
  storeId?: string
  storeName?: string
  name: string
  address: string
  longitude: number
  latitude: number
  contactName?: string
  contactPhone?: string
  serviceRadiusKm?: number
  enabled?: boolean
  sort?: number
  remark?: string
  createdAt?: string
}

export interface DeliveryRuleSavePayload {
  id?: string
  storeId?: string
  name: string
  minOrderAmount?: number
  baseFee?: number
  freeThreshold?: number
  perKmFee?: number
  startDistanceKm?: number
  maxDistanceKm?: number
}

export interface DeliveryAreaSavePayload {
  storeId: string
  type: string
  radiusKm?: number
  polygon?: string
  feeTier?: number
  sort?: number
}

export interface DeliveryPointSavePayload {
  id?: string
  storeId?: string
  name: string
  address: string
  longitude: number
  latitude: number
  contactName?: string
  contactPhone?: string
  serviceRadiusKm?: number
  enabled?: boolean
  sort?: number
  remark?: string
}

export const deliveryApiReady = true as const

export const fetchDeliveryRules = async (): Promise<DeliveryRule[]> =>
  request<DeliveryRule[]>({
    url: '/delivery/rules',
    method: 'GET',
  })

export const updateDeliveryRule = async (payload: DeliveryRuleSavePayload): Promise<void> =>
  request<void, DeliveryRuleSavePayload>({
    url: '/delivery/rules',
    method: 'PUT',
    data: payload,
  })

export const fetchDeliveryAreas = async (): Promise<DeliveryArea[]> =>
  request<DeliveryArea[]>({
    url: '/delivery/areas',
    method: 'GET',
  })

export const createDeliveryArea = async (payload: DeliveryAreaSavePayload): Promise<void> =>
  request<void, DeliveryAreaSavePayload>({
    url: '/delivery/areas',
    method: 'POST',
    data: payload,
  })

export const deleteDeliveryArea = async (id: string): Promise<void> =>
  request<void>({
    url: `/delivery/areas/${id}`,
    method: 'DELETE',
  })

export const deleteDeliveryRule = async (id: string): Promise<void> =>
  request<void>({
    url: `/delivery/rules/${id}`,
    method: 'DELETE',
  })

export const fetchDeliveryPoints = async (keyword?: string): Promise<DeliveryPoint[]> =>
  request<DeliveryPoint[]>({
    url: '/delivery/points',
    method: 'GET',
    data: keyword ? { keyword } : undefined,
  })

export const saveDeliveryPoint = async (payload: DeliveryPointSavePayload): Promise<void> => {
  const { id, ...data } = payload
  return request<void, Omit<DeliveryPointSavePayload, 'id'>>({
    url: id ? `/delivery/points/${id}` : '/delivery/points',
    method: id ? 'PUT' : 'POST',
    data,
  })
}

export const deleteDeliveryPoint = async (id: string): Promise<void> =>
  request<void>({
    url: `/delivery/points/${id}`,
    method: 'DELETE',
  })
